import React from "react";
import ModalWrapper from "..";

interface ScanQRCodeModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
  videoRef: React.RefObject<HTMLVideoElement>;
}

const ScanQRCodeModal = ({
  isOpen,
  onOpenChange,
  videoRef,
}: ScanQRCodeModalProps) => {
  return (
    <ModalWrapper
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      descriptionStyles="py-0"
      crossStyles="text-white"
    >
      <div className="relative w-full flex items-center justify-center">
        <video ref={videoRef} className="w-full h-auto" />
      </div>
    </ModalWrapper>
  );
};

export default React.memo(ScanQRCodeModal);
